import { render } from "./DashboardMetricCard.vue?vue&type=template&id=1712dd6d"
import script from "./DashboardMetricCard.vue?vue&type=script&lang=js"
export * from "./DashboardMetricCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__